import { LoadableSubscription } from './LoadableSubscription';

// we can get composite subscription through opts.dependsOn.render?.subscription().sub

type CompositeLoadableSubscriptionOptions = any & {
  dependsOn?: LoadableSubscription;
};

export class CompositeLoadableSubscription extends LoadableSubscription {
  constructor(loadFn, opts: CompositeLoadableSubscriptionOptions) {
    if (opts.dependsOn) {
      opts.dependsOn.render?.preload();
    }
    super(loadFn, opts);
  }

  promise(): any {
    if (this.hasDependsOnSubscription()) {
      return Promise.all([super.promise(), this.getDependsOnSubscription().promise()]);
    }
    return super.promise();
  }

  retry() {
    super.retry();
    if (this.hasDependsOnSubscription()) {
      this.getDependsOnSubscription()
        .promise()
        .finally(() => {
          // defer update child state when upstream component script downloaded
          this._update({});
          this._clearTimeouts();
        });
      const onRenderedSub = this.getDependsOnSubscription().subscribeOnRendered(() => {
        this._update({});
        this._clearTimeouts();
        onRenderedSub(); // de-register subscription
      });
    }
  }

  _update(partial) {
    if (this.hasDependsOnSubscription()) {
      this._state = {
        ...this._state,
        error: this._res.error || this.getDependsOnSubscription().error,
        loading:
          this._res.loading ||
          this.getDependsOnSubscription().loading ||
          !this.getDependsOnSubscription().rendered,
        loaded: this._res.loaded, // this is the element loaded from server
        ...partial,
      };
    } else {
      this._state = {
        ...this._state,
        error: this._res.error,
        loaded: this._res.loaded,
        loading: this._res.loading,
        ...partial,
      };
    }

    this._callbacks.forEach((callback) => callback());
  }

  protected hasDependsOnSubscription() {
    return !!this._opts?.dependsOn?.render?.subscription;
  }

  protected getDependsOnSubscription() {
    if (this.hasDependsOnSubscription()) {
      return this._opts.dependsOn.render.subscription().sub as LoadableSubscription;
    }
  }
}
